<template>
  <div>
    <ModifyApi v-if="modifyApiShow" :getApiList="getApiList"></ModifyApi>
    <div class="api-management" v-if="!modifyApiShow">
      <div class="api-management-header main-second-bg a-3-bd clearfix">
        <c-navTab
          activeClassName="b-1-cl"
          activeColor="a-12-bg"
          className="b-2-cl"
          :currentTab="currentTab"
          :navTab="navTab"
          :lineHeight="lineHeight"
          :marginRight="marginRight"
          @currentType="currentType"
        />
      </div>
      <div class="api-management-center">
        <div class="center1" v-show="currentTab === 1">
          <div class="topArea main-second-bg">
            <div class="center1-header">
              <p class="center1-title red-cl">
                <svg-icon class="icon icon-14" icon-class="warningIcon"></svg-icon>
                <span>{{ $t("personal.prompt.warningApi") }}</span>
              </p>
            </div>
            <div class="center1-inputs">
              <div class="center1-input">
                <c-inputLine
                  name="ip"
                  inputType="text"
                  :promptText="promptText1"
                  :errorHave="true"
                  :errorText="errorText1"
                  :errorFlag="checkErrorFlag1"
                  marginTop="0px"
                  :value="checkValue1"
                  @onchanges="inputChanges"
                  newStyleFormat
                >
                </c-inputLine>
              </div>
              <div class="center1-input">
                <c-inputLine
                  name="note"
                  maxLength="25"
                  inputType="text"
                  :promptText="promptText2"
                  :errorHave="true"
                  :errorText="errorText2"
                  :errorFlag="checkErrorFlag2"
                  marginTop="0px"
                  :value="checkValue2"
                  @onchanges="inputChanges"
                  newStyleFormat
                >
                </c-inputLine>
              </div>
              <div class="center1-input" v-show="smsCode">
                <c-inputLine
                  maxLength="6"
                  name="phoneCode"
                  inputType="text"
                  :promptText="promptText3"
                  :errorHave="true"
                  :errorText="errorText3"
                  :errorFlag="checkErrorFlag3"
                  marginTop="0px"
                  :value="checkValue3"
                  @onchanges="inputChanges"
                  newStyleFormat
                >
                  <!-- 获取验证码 -->
                  <c-getCode
                    name="phone"
                    :autoStart="autoStart"
                    @click="getCodeClick"
                    buttonName="loginGetcodeBtn"
                  />
                </c-inputLine>
              </div>
              <div class="center1-input" v-show="googleCode">
                <c-inputLine
                  name="googleCode"
                  maxLength="6"
                  inputType="text"
                  :promptText="promptText4"
                  :errorHave="true"
                  :errorText="errorText4"
                  :errorFlag="checkErrorFlag4"
                  marginTop="0px"
                  :value="checkValue4"
                  @onchanges="inputChanges"
                  newStyleFormat
                >
                </c-inputLine>
              </div>
              <div class="center1-button">
                <c-button
                  type="solid"
                  :big="true"
                  className=""
                  :loading="loading2"
                  paddingW="0px"
                  :disabled="disabled"
                  marginTop="18px"
                  height="40px"
                  width="447px"
                  @click="btnLink"
                  >{{ $t("personal.tool.create") }}</c-button
                >
              </div>
            </div>
          </div>
          <div class="center1-table main-second-bg a-7-bd">
            <p class="center1-title2 a-3-bd b-1-cl">
              {{ $t("personal.APImanagement.recordTitle") }}
            </p>
            <c-table
              :imgMap="imgMap"
              :colorMap="colorMap"
              :loading="loading"
              :classes="classes"
              :headClasses="headClasses"
              :bodyClasses="bodyClasses"
              :lineClasses="lineClass"
              :columns="columns"
              :dataList="apiList"
              :lineNumber="lineNumber"
              :cellHeight="cellHeight"
              :headHeight="headHeight"
              @elementClick="deleteData"
            />
            <c-pagination
              v-show="count !== 0"
              :total="count"
              :current-page="page"
              :display="pageSize"
              @pagechange="pagechange"
            >
            </c-pagination>
          </div>
        </div>
        <div class="center2 main-second-bg" v-show="currentTab === 2">
          <a
            href="https://github.com/exchange-doc/api/blob/master/api/zh_cn/api_doc_cn.md"
            @mouseenter="handMouseenter"
            @mouseleave="handMouseleave"
            target="_blank"
            class="api-down a-12-bd b-2-cl"
            >{{ $t("personal.APImanagement.downloadDocumen") }}</a
          >
          <c-table
            :imgMap="imgMap"
            :colorMap="colorMap"
            :classes="classes"
            :headClasses="headClasses"
            :bodyClasses="bodyClasses"
            :lineClasses="lineClass"
            :columns="columns2"
            :dataList="apiList2"
            :lineNumber="lineNumber"
            :cellHeight="cellHeight"
            :headHeight="headHeight"
            @elementClick="deleteData"
          />
        </div>
        <div class="center3 main-second-bg" v-show="currentTab === 3">
          <a
            href="https://github.com/exchange-doc/api/blob/master/api/zh_cn/api_doc_cn.md"
            target="_blank"
            @mouseenter="handMouseenter"
            @mouseleave="handMouseleave"
            class="api-down a-12-bd b-2-cl"
            >{{ $t("personal.APImanagement.downloadDocumen") }}</a
          >
          <c-table
            :imgMap="imgMap"
            :colorMap="colorMap"
            :classes="classes"
            :headClasses="headClasses"
            :bodyClasses="bodyClasses"
            :lineClasses="lineClass"
            :columns="columns2"
            :dataList="apiList3"
            :lineNumber="lineNumber"
            :cellHeight="cellHeight"
            :headHeight="headHeight"
            @elementClick="deleteData"
          />
        </div>
      </div>
      <c-dialog
        :showFlag="dialogFlag"
        paddingBottom="14px"
        :confirmLoading="dialogConfirmLoading"
        :confirmDisabled="dialogConfirmDisabled"
        @close="dialogClose"
        @confirm="dialogConfirm"
        :titleText="titleText"
      >
        <div class="dialog-div a-4-bg">
          <ul>
            <li class="a-5-bd">
              <p class="b-2-cl">{{ $t("personal.APImanagement.secretKey") }}</p>
              <p class="b-2-cl">
                {{ secretKey }}
                <span
                  @click="copyClick('secretKey')"
                  @mouseenter="handMouseenters('secretKey')"
                  @mouseleave="handMouseleaves('secretKey')"
                  >>
                  <span v-if="secretKeyShow">
                    <svg class="icon icon-14" aria-hidden="true">
                      <use xlink:href="#icon-a_9"></use>
                    </svg>
                  </span>
                  <span v-else>
                    <svg class="icon icon-14" aria-hidden="true">
                      <use xlink:href="#icon-a_9_1"></use>
                    </svg>
                  </span>
                </span>
              </p>
            </li>
            <li class="a-5-bd">
              <p class="b-2-cl">{{ $t("personal.APImanagement.APIKye") }}</p>
              <p class="b-2-cl">
                {{ apiKey }}
                <span
                  @click="copyClick('apiKey')"
                  @mouseenter="handMouseenters('apiKey')"
                  @mouseleave="handMouseleaves('apiKey')"
                >
                  <span v-if="apiKeyShow">
                    <svg class="icon icon-14" aria-hidden="true">
                      <use xlink:href="#icon-a_9"></use>
                    </svg>
                  </span>
                  <span v-else>
                    <svg class="icon icon-14" aria-hidden="true">
                      <use xlink:href="#icon-a_9_1"></use>
                    </svg>
                  </span>
                </span>
              </p>
            </li>
            <li class="b-4-bd">
              <p class="b-2-cl">{{ $t("personal.APImanagement.ip") }}</p>
              <p class="b-2-cl">{{ checkValue1 }}</p>
            </li>
          </ul>
        </div>
      </c-dialog>
      <!-- 提示框 -->
      <c-alert
        :showFlag="alertFlag"
        :buttonText="$t('assets.addressMent.GotoOpen')"
        :imgMap="imgMap"
        @close="alertClose"
        @confirm="alertGo"
        :title="$t('personal.alert.title')"
      >
        <!-- <div class="alertTitle b-2-cl">{{ $t("personal.alert.title") }}</div> -->
        <div class="alertText">{{ $t("personal.alert.text") }}</div>
        <div class="alertError gray-10-bd">
          <span class="alertError-text main-cl">{{
            $t("personal.alert.alertErrorTextGoogle")
          }}</span>
          <span class="alertError-icon">+</span>
        </div>
        <div class="alertError alertBot gray-10-bd">
          <span class="alertError-text main-cl">{{ $t("personal.alert.alertErrorTextPhone") }}</span>
          <span class="alertError-icon">+</span>
        </div>
      </c-alert>
    </div>
  </div>
</template>

<script>
import { imgMap, colorMap } from '@/utils';
import ModifyApi from './modifyApi.vue';

export default {
  name: 'apiManagement',
  components: {
    ModifyApi,
  },
  data() {
    return {
      titleText: this.$t('personal.APImanagement.titleText'),
      loading: true,
      loading2: false,
      imgMap,
      colorMap,
      alertFlag: false,
      // Table
      columns: [
        {
          title: this.$t('personal.APImanagement.columns')[0],
          align: 'left',
          width: '200px',
          classes: '',
        },
        {
          title: this.$t('personal.APImanagement.columns')[1],
          align: 'left',
          width: '200px',
        },
        {
          title: this.$t('personal.APImanagement.columns')[2],
          align: 'left',
          width: '200px',
        },
        {
          title: this.$t('personal.APImanagement.columns')[3],
          align: 'left',
          width: '100px',
        },
        {
          title: this.$t('personal.APImanagement.columns')[4],
          align: 'left',
          width: '150px',
        },
      ],
      columns2: [
        {
          title: `${this.$t('personal.APImanagement.columnsApi')[0]}`,
          align: 'left',
          width: '50%',
          classes: '',
        },
        {
          title: this.$t('personal.APImanagement.columnsApi')[1],
          align: 'left',
          width: '50%',
        },
      ],
      apiList: [],
      apiList2: [
        {
          data: ['/open/api/get_records', this.$t('personal.APImanagement.apiList')[0]],
        },
        {
          data: ['/open/api/get_ticker', this.$t('personal.APImanagement.apiList')[1]],
        },
        {
          data: ['/open/api/get_trades', this.$t('personal.APImanagement.apiList')[2]],
        },
        {
          data: ['/open/api/market_dept', this.$t('personal.APImanagement.apiList')[3]],
        },
      ],
      apiList3: [
        {
          data: ['/open/api/all_order', this.$t('personal.APImanagement.apiList')[4]],
        },
        {
          data: ['/open/api/all_trade', this.$t('personal.APImanagement.apiList')[5]],
        },
        {
          data: ['/open/api/cancel_order', this.$t('personal.APImanagement.apiList')[6]],
        },
        {
          data: ['/open/api/common/symbols', this.$t('personal.APImanagement.apiList')[7]],
        },
        {
          data: ['/open/api/create_order', this.$t('personal.APImanagement.apiList')[8]],
        },
        {
          data: ['/open/api/market', this.$t('personal.APImanagement.apiList')[9]],
        },
        {
          data: ['/open/api/new_order', this.$t('personal.APImanagement.apiList')[10]],
        },
        {
          data: ['/open/api/order_info', this.$t('personal.APImanagement.apiList')[11]],
        },
        {
          data: ['/open/api/user/account', this.$t('personal.APImanagement.apiList')[12]],
        },
      ],
      cellHeight: 55,
      headHeight: 30,
      lineNumber: 10,
      classes: '',
      headClasses: '',
      bodyClasses: '',
      lineClass: '',
      count: 0,
      page: 1,
      pageSize: 10,
      secretKey: '',
      apiKey: '',
      // 弹框相关
      dialogFlag: false,
      dialogConfirmLoading: false,
      dialogConfirmDisabled: false,
      // input相关参数
      promptText1: this.$t('personal.APImanagement.ip'),
      errorText1: this.$t('personal.prompt.ipCode'),
      checkErrorFlag1: false,
      checkValue1: '',
      promptText2: this.$t('personal.APImanagement.note'),
      errorText2: this.$t('personal.prompt.noteCode'),
      checkErrorFlag2: false,
      checkValue2: '',
      promptText3: this.$t('personal.label.smsCodeText'),
      errorText3: this.$t('personal.prompt.errorCode'),
      checkErrorFlag3: false,
      checkValue3: '',
      promptText4: this.$t('personal.label.googleCodeText'),
      errorText4: this.$t('personal.prompt.errorCode'),
      checkErrorFlag4: false,
      checkValue4: '',
      // 发送验证码
      autoStart: false,
      // button
      disabled: true,
      // 横向导航参数
      currentTab: 1,
      navTab: [
        {
          name: this.$t('personal.APImanagement.navTab')[0],
          index: 1,
        },
        {
          name: this.$t('personal.APImanagement.navTab')[1],
          index: 2,
        },
        {
          name: this.$t('personal.APImanagement.navTab')[2],
          index: 3,
        },
      ],
      lineHeight: '55',
      marginRight: 48, // 距离右边的距离
      smsCode: false, // false对应0 关闭 true对应1 开启(手机短信认证)
      googleCode: false, // false对应0 关闭 true对应1 开启(google认证)
      delete: true, // 删除按钮的可点击状态
      secretKeyShow: true,
      apiKeyShow: true,
    };
  },
  computed: {
    modifyApiShow() {
      return this.$store.state.personal.modifyApiShow;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    sendSmsCode() {
      return this.$store.state.personal.sendSmsCode;
    },
    createOpenApi() {
      return this.$store.state.personal.createOpenApi;
    },
    myApiList() {
      return this.$store.state.personal.myApiList;
    },
    api() {
      return imgMap.api;
    },
    apiUrl() {
      const data = {
        2: '',
        3: '',
      };
      try {
        const url = this.$store.state.baseData.publicInfo.url.exUrl;
        const nUrls = url.match(/(.+)\/\/(.+)?\/?/i);
        const protocol = nUrls[1];
        const nUrl = nUrls[2];
        data[2] = `(${protocol.indexOf('s') > -1 ? 'wss' : 'ws'}://${nUrl.replace(
          nUrl.substring(0, nUrl.indexOf('.')),
          'ws',
        )})`;
        data[3] = `(${protocol}//${nUrl.replace(nUrl.substring(0, nUrl.indexOf('.')), 'openapi')})`;
      } catch (e) {
        // console.log(e)
      }
      return data;
    },
  },
  watch: {
    userInfo(userInfo) {
      if (userInfo !== null) {
        this.googleCode = !!Number(userInfo.googleStatus);
        this.smsCode = !!Number(userInfo.isOpenMobileCheck);
      }
    },
    sendSmsCode(sendSmsCode) {
      if (sendSmsCode !== null) {
        if (sendSmsCode.text === 'success') {
          this.$bus.$emit('tip', { text: sendSmsCode.msg, type: 'success' });
          this.$store.dispatch('resetType');
        } else {
          this.$bus.$emit('getCode-clear', 'phone');
          this.$bus.$emit('tip', { text: sendSmsCode.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    createOpenApi(createOpenApi) {
      if (createOpenApi !== null) {
        this.loading2 = false;
        if (createOpenApi.text === 'success') {
          this.$bus.$emit('tip', { text: createOpenApi.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.dialogConfirm();
          // 再次获取apilist
          const info = { page: this.page, pageSize: this.pageSize };
          this.$store.dispatch('myApiList', info);
        } else {
          this.$bus.$emit('tip', { text: createOpenApi.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    myApiList(myApiList) {
      if (myApiList !== null) {
        this.loading = false;
        setTimeout(() => {
          this.delete = true;
        }, 300);
        this.processData(myApiList.apiList);
        if (myApiList.count > 10) {
          this.count = myApiList.count;
        } else if (myApiList.count === 0) {
          this.apiList = [];
        }
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { userInfo } = this.$store.state.baseData;
      if (userInfo !== null) {
        this.googleCode = !!Number(userInfo.googleStatus);
        this.smsCode = !!Number(userInfo.isOpenMobileCheck);
        if (!this.smsCode && !this.googleCode) {
          this.alertFlag = true;
        } else {
          this.alertFlag = false;
        }
      }
      this.getApiList();
    },
    getApiList() {
      const info = { page: this.page, pageSize: this.pageSize };
      this.$store.dispatch('myApiList', info);
    },
    handMouseenters(name) {
      if (name === 'secretKey') {
        this.secretKeyShow = false;
      } else {
        this.apiKeyShow = false;
      }
    },
    handMouseleaves(name) {
      if (name === 'secretKey') {
        this.secretKeyShow = true;
      } else {
        this.apiKeyShow = true;
      }
    },
    handMouseenter(e) {
      e.target.classList.add('b-4-cl');
      e.target.classList.remove('b-2-cl');
    },
    handMouseleave(e) {
      e.target.classList.add('b-2-cl');
      e.target.classList.remove('b-4-cl');
    },
    alertClose() {
      this.$router.push('/personal/UserManagement');
    },
    alertGo() {
      this.$router.push('/personal/UserManagement');
    },
    codeFlag(val) {
      return this.$store.state.regExp.verification.test(val);
    },
    ipFlag(val) {
      return new RegExp(this.$store.state.regExp.ip, 'g').test(val);
    },
    numbers(val) {
      return this.$store.state.regExp.numbers.test(val);
    },
    pagechange(page) {
      this.page = page;
      const info = { page, pageSize: this.pageSize };
      this.$store.dispatch('myApiList', info);
    },
    processData(list) {
      // 处理数据
      if (list !== null) {
        this.apiList = list.map(obj => ({
          id: { token: obj.token, ip: obj.believeIps, label: obj.label },
          data: [
            obj.label,
            this.getIpList(obj.believeIps),
            obj.token,
            [
              {
                type: 'button', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                text: this.$t('personal.tool.view'),
                iconClass: [''],
                eventType: 'check',
                classes: [''],
              },
            ],
            [
              {
                type: 'button', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                text: this.$t('personal.tool.modify'),
                iconClass: [''],
                eventType: 'modify',
                classes: [''],
              },
              {
                type: 'button', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                text: this.$t('personal.tool.delete'),
                iconClass: [''],
                eventType: 'delete',
                classes: [''],
              },
            ],
          ],
        }));
      }
    },
    getIpList(ips) {
      if (!ips) {
        return '';
      }
      const ipArr = ips.split(',');
      return ipArr.map(item => ({
        type: 'html',
        text: `<div style="margin:4px 0;">${item}</div>`,
      }));
    },
    deleteData(type, obj) {
      // const info = obj.token;
      switch (type) {
        case 'delete':
          if (this.delete) {
            this.delete = false;
            this.axios({
              url: this.$store.state.url.common.delete_open_api,
              method: 'post',
              params: { token: obj.token },
            }).then((data) => {
              if (data.code === '0') {
                this.$bus.$emit('tip', { text: data.msg, type: 'success' });
                this.$store.dispatch('resetType');
                // 重新请求apilist
                const info = { page: this.page, pageSize: this.pageSize };
                this.$store.dispatch('myApiList', info);
              } else {
                this.$bus.$emit('tip', { text: data.msg, type: 'error' });
                this.$store.dispatch('resetType');
              }
            });
          }
          break;
        case 'check':
          this.$store.dispatch('setApiToken', obj.token);
          this.$router.push('/personal/checkApi');
          break;
        case 'modify':
          this.$store.dispatch('setApiToken', obj.token);
          this.$store.dispatch('setIp', obj.ip);
          this.$store.dispatch('setLabel', obj.label);
          this.$store.dispatch('setModifyApiShow', true);
          break;
        default:
      }
    },
    copyClick(name) {
      // 粘贴
      if (name === 'apiKey') {
        this.copy(this.apiKey);
      } else {
        this.copy(this.secretKey);
      }
    },
    copy(str) {
      // this.$bus.$emit('tip', { text: this.$t('personal.prompt.copySucces'), type: 'success' });
      function save(e) {
        e.clipboardData.setData('text/plain', str); // 下面会说到clipboardData对象
        e.preventDefault(); // 阻止默认行为
      }
      document.addEventListener('copy', save);
      document.execCommand('copy'); // 使文档处于可编辑状态，否则无效
      document.removeEventListener('copy', save);
    },
    dialogClose() {
      // 关闭或取消时
      this.dialogConfirmFlag = false;
      this.dialogFlag = false;
      this.checkValue = this.oldName;
      // 重置所有项
      this.checkValue1 = '';
      this.checkValue2 = '';
      this.checkValue3 = '';
      this.checkValue4 = '';
      this.disabled = true;
      this.$bus.$emit('getCode-clear', 'phone');
    },
    dialogConfirm() {
      this.dialogConfirmFlag = false;
      this.dialogFlag = false;
      this.checkValue = this.oldName;
      // 重置所有项
      this.checkValue1 = '';
      this.checkValue2 = '';
      this.checkValue3 = '';
      this.checkValue4 = '';
      this.disabled = true;
      this.$bus.$emit('getCode-clear', 'phone');
    },
    currentType(data) {
      this.columns2 = [
        {
          title: `${this.$t('personal.APImanagement.columnsApi')[0]} ${this.apiUrl[data.index]}`,
          align: 'left',
          width: '50%',
          classes: '',
        },
        {
          title: this.$t('personal.APImanagement.columnsApi')[1],
          align: 'left',
          width: '50%',
        },
      ];
      this.currentTab = data.index;
    },
    dealIp(value) {
      let a = true;
      if (value.indexOf(',') !== -1) {
        if (value.charAt(value.length - 1) === ',') {
          // 如果最后一位是,删除最后一位再进行处理
          const attr = value.substring(0, value.length - 1).split(',');
          const len = attr.length;
          if (len <= 5) {
            attr.forEach((obj) => {
              if (this.ipFlag(obj)) {
                a = true;
              } else {
                a = false;
              }
            });
          } else {
            a = false;
          }
        } else {
          // 否则正常处理
          const attr = value.split(',');
          const len = attr.length;
          if (len <= 5) {
            attr.forEach((obj) => {
              if (this.ipFlag(obj)) {
                a = true;
              } else {
                a = false;
              }
            });
          } else {
            a = false;
          }
        }
      } else {
        a = this.ipFlag(value);
      }
      return a;
    },
    inputChanges(val, name) {
      switch (name) {
        case 'ip':
          this.checkValue1 = val;
          if (val) {
            if (this.dealIp(val)) {
              this.checkErrorFlag1 = false;
            } else {
              this.checkErrorFlag1 = true;
            }
          } else {
            this.checkErrorFlag1 = false;
          }
          break;
        case 'note':
          this.checkValue2 = val;
          if (this.checkValue2) {
            this.checkErrorFlag2 = false;
          } else {
            this.checkErrorFlag2 = true;
          }
          break;
        case 'phoneCode':
          this.checkValue3 = val;
          if (this.codeFlag(val)) {
            this.checkErrorFlag3 = false;
          } else {
            this.checkErrorFlag3 = true;
          }
          break;
        default:
          this.checkValue4 = val;
          if (this.codeFlag(val)) {
            this.checkErrorFlag4 = false;
          } else {
            this.checkErrorFlag4 = true;
          }
      }
      if (
        this.checkValue2
        && !this.checkErrorFlag3
        && !this.checkErrorFlag4
        && !this.checkErrorFlag1
        && !this.checkErrorFlag2
      ) {
        if (this.smsCode) {
          this.disabled = !this.checkValue3;
        }
        if (this.googleCode) {
          this.disabled = !this.checkValue4;
        }
        if (this.smsCode && this.googleCode) {
          this.disabled = !(this.checkValue3 && this.checkValue4);
        }
      } else {
        this.disabled = true;
      }
    },
    getCodeClick() {
      this.$bus.$emit('getCode-start', 'phone');
      const info = { operationType: 16 };
      this.$store.dispatch('sendSmsCode', info);
    },
    btnLink() {
      this.loading2 = true;
      const info = {
        believeIps: this.checkValue1,
        label: this.checkValue2,
        smsValidCode: this.checkValue3,
        googleCode: this.checkValue4,
      };
      this.$store.dispatch('createOpenApi', info);
    },
  },
};
</script>

<style lang="scss" scoped>
.api-management {
  width: 100%;
  min-height: 800px;

  /deep/ .myIpItem {
    display: block;
    text-align: left;
  }

  .api-management-header {
    font-size: 14px;
    width: 100%;
    padding-left: 30px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }
  .api-management-center {
    .center1 {
      width: 100%;

      .topArea {
        padding: 24px;
      }

      .center1-title2 {
        font-size: 14px;
        padding: 18px 20px;
        border-bottom-width: 1px;
        border-bottom-style: solid;
      }

      .center1-img {
        position: absolute;
        right: 0;
        top: 173px;
      }
      .center1-header {
        margin-bottom: 40px;
        .center1-title {
          font-size: 12px;
          span {
            margin-left: 10px;
            width: 400px;
            line-height: 18px;
          }
        }
      }
      .center1-inputs {
        display: flex;
        flex-wrap: wrap;

        .center1-input {
          width: 447px;
        }
        .center1-button {
          width: 100%;
        }
        .center1-input:nth-of-type(odd) {
          margin-right: 20px;
        }
      }
      .center1-table {
        width: 100%;
        margin-top: 24px;
      }
    }
    .center2 {
      width: 100%;
      min-height: 744px;
      .api-down {
        padding: 0 20px;
        height: 30px;
        box-sizing: border-box;
        border-style: solid;
        border-width: 1px;
        font-size: 12px;
        text-align: center;
        line-height: 30px;
        margin: 20px;
        display: inline-block;
      }
    }
    .center3 {
      min-height: 744px;
      .api-down {
        width: 100px;
        height: 30px;
        box-sizing: border-box;
        border-style: solid;
        border-width: 1px;
        font-size: 12px;
        text-align: center;
        line-height: 30px;
        margin: 20px;
        display: inline-block;
      }
    }
  }
  .dialog-div {
    ul {
      width: 100%;
      li {
        height: 70px;
        border-bottom-style: solid;
        border-bottom-width: 1px;
        padding: 0 20px;
        p:nth-of-type(1) {
          padding-top: 17px;
          font-size: 12px;
        }
        p:nth-of-type(2) {
          overflow: hidden;
          font-size: 14px;
        }
      }
    }
  }
  .alertTitle {
    margin-bottom: 15px;
  }
  .alertText {
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    padding: 16px 24px 24px;
    box-sizing: border-box;
  }
  .alertError {
    height: 40px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding: 10px 24px;
    box-sizing: border-box;
    .alertError-text {
      font-size: 14px;
      line-height: 20px;
      margin-left: 8px;
    }
  }
  .alertBot {
    margin-bottom: 16px;
  }
  .dialog-div {
    svg {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
</style>
